import { useContext } from 'react';

import { HeadquarterContext } from 'context/HeadquarterContext';
import { useAuth } from 'hooks/useAuth';

import { MENU_EDITOR } from 'constants/chownow';

import Cover from 'primitives/Cover/Cover';
import MenuManagement from './MenuManagement/MenuManagement';
import LegacyMenu from './LegacyMenu';
import { RedirectMiddleware } from './RedirectMiddleware';
import { RedirectPOSIntegrations } from './RedirectPOSIntegrations';

export default function ManageMenus() {
  const { isSingleMerchantType } = useContext(HeadquarterContext);

  return (
    <>
      <Cover title="Menu Editor">{isSingleMerchantType && <ManageMenus.ActionsDropdown />}</Cover>
      <ManageMenus.MenuEditor />
    </>
  );
}

ManageMenus.MenuEditor = function MenuEditor() {
  const { isUserCubohOnly } = useAuth();
  const { location } = useContext(HeadquarterContext);

  if (isUserCubohOnly) {
    return <MenuManagement />;
  }

  switch (location?.menu_editor) {
    case MENU_EDITOR.toast:
      return <RedirectPOSIntegrations />;
    case MENU_EDITOR.cuboh:
      return <MenuManagement />;
    case MENU_EDITOR.middleware:
      return <RedirectMiddleware />;
    case MENU_EDITOR.legacy:
    default:
      return <LegacyMenu />;
  }
};

ManageMenus.ActionsDropdown = function ActionsDropdown() {
  // This will be populated by MenuDisplay via portal
  return null;
};
